import { useEffect } from 'react';
import { usePage } from '../../context/PageContext';
import { t } from '../../utils/i18n';
import './index.css';

export default function ArckPage() {
    const { navigate } = usePage();

    useEffect(() => {
        document.title = 'ARCK · The Arc of Scientific Intelligence';

        const publicUrl = process.env.PUBLIC_URL || '';
        fetch(`${publicUrl}/arck/index.html`)
            .then(res => res.text())
            .then(html => {
                const container = document.getElementById('arck-root');
                if (!container) return;

                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');

                // Inject styles
                const styles = doc.querySelectorAll('style');
                styles.forEach(style => {
                    const el = document.createElement('style');
                    el.textContent = style.textContent;
                    document.head.appendChild(el);
                    el.setAttribute('data-arck', 'true');
                });

                // Inject body content
                container.innerHTML = doc.body.innerHTML;

                // Execute scripts in isolated scope (skip non-JS like application/json)
                const scripts = doc.querySelectorAll('body script');
                scripts.forEach(script => {
                    const type = script.getAttribute('type');
                    if (type && type !== 'text/javascript') return;
                    const el = document.createElement('script');
                    el.textContent = `{${script.textContent}}`;
                    container.appendChild(el);
                });
            });

        return () => {
            // Cleanup styles on unmount
            document.querySelectorAll('style[data-arck]').forEach(el => el.remove());
            const container = document.getElementById('arck-root');
            if (container) container.innerHTML = '';
        };
    }, []);

    return (
        <div className="arck-page-wrapper">
            <button
                className="arck-back-btn"
                onClick={() => navigate('/')}
            >
                {t('返回首页', 'Back to Home')}
            </button>
            <div id="arck-root" className="arck-page-root" />
        </div>
    );
}
